import http from './httpRequest.js'

class PromotionApi {
}

// 管理端:查询全部推广(含禁用)
PromotionApi.prototype.listAll = function () {
	return http({
		url: '/admin/promotion/list',
		method: 'get'
	})
}

// 管理端:新增推广
PromotionApi.prototype.add = function (data) {
	return http({
		url: '/admin/promotion',
		method: 'post',
		data: data
	})
}

// 管理端:修改推广
PromotionApi.prototype.update = function (data) {
	return http({
		url: '/admin/promotion',
		method: 'put',
		data: data
	})
}

// 管理端:删除推广
PromotionApi.prototype.remove = function (id) {
	return http({
		url: '/admin/promotion/' + id,
		method: 'delete'
	})
}

export default PromotionApi
